import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Search: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.33301 8.33301C4.33301 6.12387 6.12387 4.33301 8.33301 4.33301C10.5421 4.33301 12.333 6.12387 12.333 8.33301C12.333 10.5421 10.5421 12.333 8.33301 12.333C6.12387 12.333 4.33301 10.5421 4.33301 8.33301ZM8.33301 2.33301C5.0193 2.33301 2.33301 5.0193 2.33301 8.33301C2.33301 11.6467 5.0193 14.333 8.33301 14.333C9.68939 14.333 10.9406 13.8829 11.9456 13.124L14.8971 16.0755C15.2225 16.4009 15.7501 16.4009 16.0756 16.0755C16.401 15.75 16.401 15.2224 16.0756 14.8969L13.1241 11.9454C13.883 10.9405 14.333 9.68932 14.333 8.33301C14.333 5.0193 11.6467 2.33301 8.33301 2.33301Z"
        fill={color}
      />
    </svg>
  );
};

export default Search;
